module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"loginAs":"Vælg bruger til at logge ind som"}}')
  delete Component.options._Ctor
}
